export default {
  bookList: [],
  bookListLoading: false,
  bookInfo: null,
  bookInfoLoading: false,
  searchParams: '',
  page: 0
}